// extracted by mini-css-extract-plugin
export default {"bodyMass":"bodyMass_bodyMass__qw+wg","title":"bodyMass_title__KR0Vi"};